<template>
    <div class="mainbusinessModuleWarp">
        <div class="moduleTitle">职业指导服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label="1.具有初级职业指导师国家资格证书：" prop="1">
                        <el-radio-group v-model="ruleForm[1]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="2.熟悉人力资源和社会保障相关法律、法规和政策、熟练掌握职业指导理论和技术：" prop="2">
                        <el-radio-group v-model="ruleForm[2]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="3.熟练使用专业工具：" prop="3">
                        <el-radio-group v-model="ruleForm[3]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="  4.本科及以上学历比例（%）：" prop="4">
                        <el-input v-model="ruleForm[4]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="5.具有中级职业指导师国家资格证书：" prop="5">
                        <el-radio-group v-model="ruleForm[5]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">二、服务场所建筑面积</div>
                    <el-form-item label=" 6.前台指导窗口数量：" prop="6">
                        <el-input v-model="ruleForm[6]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  7.职业指导角建筑面积（平方米）：" prop="7">
                        <el-input v-model="ruleForm[7]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 8.个体指导室建筑面积（平方米）：" prop="8">
                        <el-input v-model="ruleForm[8]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 9.职业测评室建筑面积（平方米）：" prop="9">
                        <el-input v-model="ruleForm[9]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 10.团体指导室建筑面积（平方米）：" prop="10">
                        <el-input v-model="ruleForm[10]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 11.网上（远程）指导室建筑面积（平方米）：" prop="11">
                        <el-input v-model="ruleForm[11]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">三、服务内容</div>
                    <el-form-item label="12.针对劳动者：应聘指导；职业信息获取指导；职业培训指导：" prop="12">
                        <el-radio-group v-model="ruleForm[12]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="13.针对用人单位：单位用人指导；人员招聘指导：" prop="13">
                        <el-radio-group v-model="ruleForm[13]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="14.人力资源和社会保障法律、法规、政策指导：" prop="14">
                        <el-radio-group v-model="ruleForm[14]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="15.针对劳动者开展职业生涯指导：" prop="15">
                        <el-radio-group v-model="ruleForm[15]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="16.针对用人单位开展在职人员指导：" prop="16">
                        <el-radio-group v-model="ruleForm[16]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="17.针对劳动者开展人才测评服务：" prop="17">
                        <el-radio-group v-model="ruleForm[17]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="18.针对用人单位开展人才测评服务：" prop="18">
                        <el-radio-group v-model="ruleForm[18]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="19.针对劳动者开展就业心理指导：" prop="19">
                        <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">四、设备设施</div>
                    <el-form-item label="20.设有液晶电视、DVD：" prop="20">
                        <el-radio-group v-model="ruleForm[20]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="21.设有传真、打印、复印、录音机等设备：" prop="21">
                        <el-radio-group v-model="ruleForm[21]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="22.设有投影、音像、笔记本电脑等设备：" prop="22">
                        <el-radio-group v-model="ruleForm[22]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="23.设有可供同时施测4-6人规模的电脑、操作台、设备柜；电子触摸屏不少于2台：" prop="23">
                        <el-radio-group v-model="ruleForm[23]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="24.设有专用服务器、计算机房及宽带设备：" prop="24">
                        <el-radio-group v-model="ruleForm[24]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">五、职业指导工具</div>
                    <el-form-item label="25.是否有职业指导业务操作系统：" prop="25">
                        <el-radio-group v-model="ruleForm[25]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="26.是否有国家就业法律、法规、政策类书籍及相关参考资料：" prop="26">
                        <el-radio-group v-model="ruleForm[26]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="27.是否有职业测评系统：" prop="27">
                        <el-radio-group v-model="ruleForm[27]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="28.是否有职业分类、职业标椎、职业常识类书籍及相关参考资料：" prop="28">
                        <el-radio-group v-model="ruleForm[28]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="29.是否有用人单位招用人员选拨软件：" prop="29">
                        <el-radio-group v-model="ruleForm[29]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="30.是否有职业供求信息、工资指导价位、就业预测分析类书籍及相关参考资料：" prop="30">
                        <el-radio-group v-model="ruleForm[30]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="31.是否有就业与创业资源评估软件：" prop="31">
                        <el-radio-group v-model="ruleForm[31]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="32.是否有创业决策指导系统：" prop="32">
                        <el-radio-group v-model="ruleForm[32]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="33.是否有其他适用于自助就业指导的资料：" prop="33">
                        <el-radio-group v-model="ruleForm[33]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">六、管理规范</div>
                    <el-form-item label="34.一般性指导管理规范的服务内容和工作流程：" prop="34">
                        <el-radio-group v-model="ruleForm[34]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="35.一般性指导管理规范、个体专门指导管理规范的服务内容和工作流程：" prop="35">
                        <el-radio-group v-model="ruleForm[35]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="36.一般性指导管理规范、个体专门指导管理规范、团体指导管理规范的服务内容和工作流程：" prop="36">
                        <el-radio-group v-model="ruleForm[36]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="37.管理规范健全，员工知晓率达（%）：" prop="37">
                        <el-input v-model="ruleForm[37]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">七、材料归档</div>
                    <el-form-item label="38.材料归档率达（%）：" prop="38">
                        <el-input v-model="ruleForm[38]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">八、客户投诉记录及处理</div>
                    <el-form-item label="39.是否设有投诉电话：" prop="39">
                        <el-radio-group v-model="ruleForm[39]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="40.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="40">
                        <el-input v-model="ruleForm[40]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="  41.是否有投诉及处理情况记录" prop="41">
                        <el-radio-group v-model="ruleForm[41]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="42.投诉及处理情况记录保存年限（年）：" prop="42">
                        <el-input v-model="ruleForm[42]" placeholder="请输入"></el-input>
                    </el-form-item>

                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: '',
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
                34: '',
                35: '',
                36: '',
                37: '',
                38: '',
                39: '',
                40: '',
                41: '',
                42: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请选择', trigger: 'change' },

                ],
                2: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],

                3: [
                    { required: true, message: '请选择', trigger: 'change' },

                ],
                4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },

                ],
                // 小数
                5: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                6: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                7: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                8: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                // 多选
                9: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                10: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                11: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                12: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                13: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                14: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                15: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                18: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                21: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                22: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                23: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                24: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                25: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                26: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                27: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                28: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                29: [
                    { required: true, message: '请选择', trigger: 'change' }

                ],
                30: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                31: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                32: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                33: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                34: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                35: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                36: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                37: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                38: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                39: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                40: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                41: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                42: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],

            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
         saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {

                    let NewDataList = []
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                            // this.$emit('update:isShow', false)
                            if (!this.isCustom) this.$destroy() // 销毁当前组件
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },
        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal4Warp {
}
</style>


